import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './InvoiceEditScreen';
import InvoiceEdit from './InvoiceEditScreen';
import { StoreState } from 'src/store/reducers';
import { getInvoice, deleteFileInvoice, getFiles, asyncCreateFilesInvoice } from 'src/store/actions/invoice-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        invoice: state.invoices.current,
        files: state.invoices.currentFiles,
        inProgress: state.invoices.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getInvoice(id)),
        getFiles: (id) => dispatch(getFiles(id)),
        addFiles: async (id, files) => await asyncCreateFilesInvoice(id, files, dispatch),
        removeFile: (id) => dispatch(deleteFileInvoice(id)),
    };
}

const InvoiceEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InvoiceEdit);

export default InvoiceEditScreen;
